// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ-styles-module--faq--1fmyT","content":"FAQ-styles-module--content--2kP20","item":"FAQ-styles-module--item--3ctZ5"};